import MainLayout from 'components/layout/MainLayout';
import AlternativeEntryMethod from "components/enter/AlternativeEntryMethod";
import Router from "next/router";
import { NextSeo } from 'next-seo'
import BackButton from 'components/BackButton'
import PageTitle from 'components/PageTitle';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import { FunnelFlags, SplitTest, trackFunnelEventIfHaveNotAlready } from 'utils/SplitTesting';
import { useEffect } from 'react';

const AlternativeEntryMethodPage = () => {
  const handleOngoingFunnelTrackingVariant = async () => {
    const variant = localStorage.getItem(`${SplitTest.OngoingFunnelTracking}_VARIANT`);
    if (variant) {
      await trackFunnelEventIfHaveNotAlready(
        SplitTest.OngoingFunnelTracking,
        FunnelFlags.VisitedPostalEntryPage,
        variant,
      );
    }
  };

  useEffect(async () => {
    await handleOngoingFunnelTrackingVariant();
  }, []);

  return (
    <MainLayout>
      <NextSeo
        title="Alternative Entry Method | DAYMADE"
        description="Learn how to enter our draws via post"
        openGraph={{
          title: 'Alternative Entry Method | DAYMADE',
          description: 'Learn how to enter our draws via post',
        }}
      />

      <PageTitle>
        <strong>Postal</strong> Entry Method
      </PageTitle>

      <PaddedMaxWidthContainer>
        <BackButton
          onClick={() => Router.back()}
        />

        <AlternativeEntryMethod />

        <BackButton
          onClick={() => Router.back()}
        />
      </PaddedMaxWidthContainer>
    </MainLayout>
  );
};

export default AlternativeEntryMethodPage;
